import { useState } from 'react'
import { Link } from 'react-router-dom'
import { SearchForm } from '../../components/admin/SearchForm'
import { Badge, Card, ErrorNote, LoadingBlock } from '../../components/ui'
import { useAdminUsers } from '../../hooks/useAdmin'
import { timeAgo } from '../../utils/format'

export function AdminUsersPage() {
  const [query, setQuery] = useState('')
  const users = useAdminUsers(query)
  return (
    <Card
      title="Users"
      actions={<SearchForm placeholder="Email or name" label="Search users" onSearch={setQuery} />}
    >
      {users.isPending ? (
        <LoadingBlock />
      ) : users.isError ? (
        <ErrorNote error={users.error} />
      ) : users.data.length === 0 ? (
        <p className="muted">No users match.</p>
      ) : (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>User</th>
                <th>Workspaces</th>
                <th>Joined</th>
                <th>Last sign-in</th>
              </tr>
            </thead>
            <tbody>
              {users.data.map((user) => (
                <tr key={user.id} className={user.status === 'active' ? undefined : 'is-muted'}>
                  <td>
                    <div className="row">
                      <strong>{user.email}</strong>
                      {user.is_admin && <Badge tone="accent">Admin</Badge>}
                      {user.status !== 'active' && <Badge tone="warn">{user.status}</Badge>}
                    </div>
                    {user.name && <div className="muted small">{user.name}</div>}
                  </td>
                  <td>
                    <div className="stack-sm">
                      {user.workspaces.map((w) => (
                        <div key={w.id} className="row small">
                          <Link to={`/studio/admin/workspaces/${w.id}`}>{w.name}</Link>
                          <span className="muted">
                            {w.role} · {w.plan}
                          </span>
                        </div>
                      ))}
                    </div>
                  </td>
                  <td className="muted" title={new Date(user.created_at).toLocaleString()}>
                    {timeAgo(user.created_at)}
                  </td>
                  <td className="muted">{user.last_login_at ? timeAgo(user.last_login_at) : 'Never'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  )
}
